import { CommonModule }     from '@angular/common';
import { NgModule }         from '@angular/core';
import { CountryComponent } from '@shared/components/country/country.component';
import { FormSelectModule } from '@shared/form-elements/form-select/form-select.module';


@NgModule({
	declarations: [
		CountryComponent
	],
	exports: [
		CountryComponent
	],
	imports: [
		CommonModule,
		FormSelectModule
	]
})
export class CountryModule {
}
